// @flow
export const FLEX_THEME_API = {
  container: '',
  item: ''
};
